<script setup>
import "@/assets/styles/mobile-viewport.css"
import { useTheme } from 'vuetify'
import initCore from '@core/initCore'
import {
  initConfigStore,
  useConfigStore,
} from '@core/stores/config'
import { hexToRgb } from '@layouts/utils'

useHead({
  meta: [{
    name: "viewport",
    content: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no",
  }],
})

// iOS can ignore viewport scale limits. Cancel its page-zoom gesture only;
// leave ordinary touch events intact for scrolling, sliders and form controls.
const preventPageZoom = event => {
  if (event.cancelable) event.preventDefault()
}
const zoomGestureEvents = ["gesturestart", "gesturechange", "gestureend"]
let iosZoomGuardInstalled = false

onMounted(() => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  if (!isIOS) return

  zoomGestureEvents.forEach(name => {
    document.addEventListener(name, preventPageZoom, { passive: false })
  })
  iosZoomGuardInstalled = true
})

onBeforeUnmount(() => {
  if (!iosZoomGuardInstalled) return
  zoomGestureEvents.forEach(name => document.removeEventListener(name, preventPageZoom))
})

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()
const { isMobile } = useDevice()
if (isMobile)
  configStore.appContentLayoutNav = 'vertical'
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <NuxtLayout>
        <NuxtPage />
        <NuxtLoadingIndicator color="rgb(var(--v-theme-primary))" />
      </NuxtLayout>
      <AppAuthFailureDialog />
      <ClientOnly>
        <AppPwaPrompt />
      </ClientOnly>
    </VApp>
  </VLocaleProvider>
</template>
